var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8038 5.64388V15.0295H31.6117V22.3815H21.8038V31.7671H14.4517V22.3815H4.65943V15.0295H14.4517V5.64388H21.8038V5.64388ZM24.6195 2.8282H11.6361V12.2138H1.84375V25.1346H11.6361V34.5202H24.6195V25.1346H34.4118V12.1512H24.6195V2.76562V2.8282Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8039 5.6438V15.0294H31.6118V22.3814H21.8039V31.767H14.4519V22.3814H4.65955V15.0294H14.4519V5.6438H21.8039V5.6438ZM23.2117 4.23596H13.044V13.6216H3.25171V23.7893H13.044V33.1749H23.243V23.7893H33.0353V13.6216H23.243V4.23596H23.2117Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6117 22.366H21.8038V31.7516H14.4517V22.366H4.65942V15.014H14.4517V5.62836H21.8038V15.014H31.6117V22.366Z",
    fill: "#FF9EDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5483 27.9191V37.3047H54.3406V44.6567H44.5483V54.0423H37.1962V44.6567H27.3883V37.3047H37.1962V27.9191H44.5483V27.9191ZM47.364 25.1347H34.3806V34.5203H24.5883V47.5037H34.3806V56.8893H47.364V47.5037H57.1563V34.5203H47.364V25.1347Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5483 27.9189V37.3045H54.3406V44.6566H44.5483V54.0422H37.1962V44.6566H27.3883V37.3045H37.1962V27.9189H44.5483V27.9189ZM45.9561 26.5267H35.7571V35.9123H25.9961V46.0801H35.7571V55.4657H45.9248V46.0801H55.7171V35.9123H45.9561V26.5267Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3406 44.6411H44.5483V54.0267H37.1962V44.6411H27.3883V37.2891H37.1962V27.9035H44.5483V37.2891H54.3406V44.6411Z",
    fill: "#EEF05D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5847 8.9444H20.3314V16.627H27.3883V17.3737H19.5847V8.9444Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7524 42.4689H39.5561V50.8826H38.8093V43.2157H31.7524V42.4689Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutres);
export default __webpack_public_path__ + "static/media/autres.90a4d1dde0387d27b1e0812e6a6a152a.svg";
export { ForwardRef as ReactComponent };